import $ from 'jquery';    
(function(){
    'use strict';


    // get metadata values from html

    var electTariffCL1 = parseFloat($('.hidden-electTariffCL1').html()),
        electTariffCL2 = parseFloat($('.hidden-electTariffCL2').html()),
        electTariffDomestic = parseFloat($('.hidden-electTariffDomestic').html()),
        gasTariff = parseFloat($('.hidden-gasTariff').html()), // eslint-disable-line no-unused-vars
        gasCharge = parseFloat($('.hidden-gasCharge').html()); // eslint-disable-line no-unused-vars

    var convertKWhToMj = parseFloat($('.hidden-convertKWhToMj').html()),
        showerHeadStandard = parseFloat($('.hidden-showerHeadStandard').html()),
        showerHeadLow = parseFloat($('.hidden-showerHeadLow').html()),
        showBathHWProportion = parseFloat($('.hidden-showBathHWProportion').html()),
        daysInYear = parseFloat($('.hidden-daysInYear').html()),
        litresPerBath = parseFloat($('.hidden-litresPerBath').html()),
        miscWaterUsePerDay = parseFloat($('.hidden-miscWaterUsePerDay').html()),
        heat1litreGas = parseFloat($('.hidden-heat1litreGas').html()),
        heat1litreElect = parseFloat($('.hidden-heat1litreElect').html()),
        efficiencyGasStorage = parseFloat($('.hidden-efficiencyGasStorage').html()),
        efficiencyGasInstant = parseFloat($('.hidden-efficiencyGasInstant').html()),
        efficiencySolarHeatPump = parseFloat($('.hidden-efficiencySolarHeatPump').html());
    
    try {
        var tankSizeRaw = $('.hidden-tank_size_vs_people');
        var tank_size_vs_people = JSON.parse(tankSizeRaw[0].innerText);
    
        var tankLossRaw = $('.hidden-tank_losses_table');
        var tank_losses_table = JSON.parse(tankLossRaw[0].innerText)
    } catch {
        return;
    }
    
 

    // simulate Matrix setting default values from metadata
    // this step is done in Matrix by setting the defaults of individual form questions
    // eg %globals_asset_metadata_hotwater-gasTariff:452%
    // comment out below lines before pushing 

    // $('.current-hotwater_gas-rate').attr('value', gasTariff);
    // $('.new-hotwater_gas-rate').attr('value', gasTariff);
    // $('.current-hotwater_gas-charge').attr('value', gasCharge);
    // $('.new-hotwater_gas-charge').attr('value', gasCharge);
    // $('.new-hotwater_electric-rate').attr('value', electTariffCL1);
    // $('.current-hotwater_electric-rate').attr('value', electTariffCL1);



    // Global variables
    let currentSystem ;
    let newSystem;
    
    class System{
        constructor(electTariff, tariffGas, chargeGas, version, optionType, generalType, tariffType, assumedTankSize, installYear, tankLoss, washerUse, totalEnergyUsed, energyUnits, efficiencyFactor, finalEnergy, calculatedCost, calculatedCostWithGasCharge) {
            this.electTariff = electTariff;
            this.tariffGas = tariffGas;
            this.chargeGas = chargeGas;
            this.version = version;
            this.optionType = optionType;
            this.generalType = generalType;
            this.tariffType = tariffType;
            this.assumedTankSize = assumedTankSize;
            this.installYear = installYear;
            this.tankLoss = tankLoss;
            this.washerUse = washerUse;
            this.totalEnergyUsed = totalEnergyUsed;
            this.energyUnits = energyUnits;
            this.efficiencyFactor = efficiencyFactor;
            this.finalEnergy = finalEnergy;
            this.calculatedCost = calculatedCost;
            this.calculatedCostWithGasCharge = calculatedCostWithGasCharge;
        }
    }


    // on page load.
    $(window).ready(function () {
        // hide fields as per default energy types
        $('.hotwater_default-hide').parent('div').parent('div').css('display', 'none');

    
        
        // create new objects for current system and new system.
        currentSystem = new System('currentSystem');
        newSystem = new System('newSystem');
    })

     // update values immediately when inputs changed
    $('input').on('change', function (input) {
        input.currentTarget.attributes.value.value = this.value;
    })

    // Hide/show fields depdending on gas/electric
    $('.hotwater_system-type').on('change', function () {
        let updatedGeneralEnergyType;
        let heatingType = this.value;
        switch (heatingType) {
            case "ElectStorage":
            case "ElectInstant":
            case "ElectSolar":
            case "ElectPump":
                $(this).closest('fieldset').find('.hotwater_gas').parent('div').parent('div').css('display', 'none');
                $(this).closest('fieldset').find('.hotwater_electric').parent('div').parent('div').css('display', 'initial');
                updatedGeneralEnergyType = 'electric';
                break;
            case "GasStorage":
            case "GasInstant":
            case "GasSolar":
                $(this).closest('fieldset').find('.hotwater_electric').parent('div').parent('div').css('display', 'none');
                $(this).closest('fieldset').find('.hotwater_gas').parent('div').parent('div').css('display', 'initial');
                updatedGeneralEnergyType = 'gas';
                break;
        }
        
        //on change, set global object optionType and generalType
        let target = this.dataset.type;
        if (target === "currentHotwaterType") {
            currentSystem.optionType = this.value;
            currentSystem.generalType = updatedGeneralEnergyType;
        } else {
            newSystem.optionType = this.value;
            newSystem.generalType = updatedGeneralEnergyType;
        }
    })


    // change tariff rate depending on selection
    $('select.hotwater_electric').on('change', function () {
        let tariffSelected = this.value;
        switch (tariffSelected) {
            case "ContLoad1":
                $(this).closest('fieldset').find('input.hotwater_electric').val(electTariffCL1); 
                break;
            case "ContLoad2":
                $(this).closest('fieldset').find('input.hotwater_electric').val(electTariffCL2); 
                break;
            case "Domestic":
                $(this).closest('fieldset').find('input.hotwater_electric').val(electTariffDomestic); 
                break;
        }
    })


    // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
    // Calculations
    // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

    // water usage
    function totalShowerWater() {
        let totalShowers = $('.hotwater_daily-showers').val();
        let aveShowerDuration = $('.hotwater_average-shower-duration').val();
        let showerhead = $('.hotwater_showerhead-type').val();
        let showerheadFlow = showerhead === "Standard" ? showerHeadStandard : showerHeadLow;  
        return totalShowers * aveShowerDuration * showerheadFlow * (showBathHWProportion / 100) * daysInYear / 1000;
    }

    function totalBathWater() {
        let totalBathes = $('.hotwater_daily-bathes').val();
        return totalBathes * litresPerBath * (showBathHWProportion / 100) * daysInYear / 1000;
    }

    function clothesWashingWater(obj) {
        let generalType = obj.generalType;
        let temp = $('.hotwater_wash-temp').val();
        let occupants = $('.hotwater_occupants').val();
        switch (generalType) {
            case "electric": {
                if (temp === "Cold") {
                    return 0;
                } else {
                    let waterUsed = (1 - 0.2) * occupants * 2 * 50;
                    return waterUsed;
                }
            }
            case "gas": {
                if (temp === "Cold") {
                    return 0;
                } else {
                    let waterUsed = ((1 - 0.2) * occupants * 2 * 50) * 3.6;
                    return waterUsed;        
                }
            }
        }
    }

    function miscWaterUse() {
        let occupants = $('.hotwater_occupants').val();
        return miscWaterUsePerDay * occupants * daysInYear / 1000;
    }
    
    // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
    // End calculations
    // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%





    
    
    // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
    // Building object values
    // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

    function setGeneralEnergyType(object) {
        let generalEnergyType;
        switch (object.optionType) {
            case "ElectStorage":
            case "ElectInstant":
            case "ElectSolar":
            case "ElectPump":
                generalEnergyType = "electric"
                break;
            case "GasStorage":
            case "GasInstant":
            case "GasSolar":
                generalEnergyType = "gas"
                break;
        }
        object.generalType = generalEnergyType;
    }

    function setTariffValues(object, system) {

        object.version = system;

        let shortVersion = object.version === 'currentSystem' ? 'current': 'new';

        object.tariffType = $(`.${shortVersion}-hotwater_elect-tariff`).val();
        object.electTariff = $(`.${shortVersion}-hotwater_electric-rate`).val();
        object.tariffGas = $(`.${shortVersion}-hotwater_gas-rate`).val();
        object.chargeGas = $(`.${shortVersion}-hotwater_gas-charge`).val();
    }

    

    function updateAssumedTankSize(obj) {
        let tankSize;
        if (obj.optionType === "GasInstant" || obj.optionType === "ElectInstant") {
            obj.assumedTankSize = 0;
        } else {
            let index = $('.hotwater_occupants').val() - 1;
            if (obj.generalType === "gas") {
                tankSize = tank_size_vs_people[index]["GT"]
            } else if (obj.generalType === "electric" && obj.tariffType === "Domestic") {
                tankSize = tank_size_vs_people[index]["DT"]
            } else if (obj.generalType === "electric") {
                tankSize = tank_size_vs_people[index]["CL"]
            }
        }
        obj.assumedTankSize = tankSize;
    }

    function setInstallYear(obj){
        let installed;
        if (obj.version === "currentSystem") {
            installed = $('.current-hotwater_install-year').val();
        } else {
            installed = $('.new-hotwater_install-year').val();
        }
        if (installed === "unknown") {
            installed = "before99"
        }
        obj.installYear = installed;
    }

    // energy need for total water usage
    function energyRequired(obj) {
        let tankLoss = 0;
        let heatFactor;

        switch (obj.generalType) {
            case "electric": {
                heatFactor = heat1litreElect;
                obj.energyUnits = 'Electricity (kWh)';
                if (obj.optionType !== "ElectInstant") {
                    tankLoss = tank_losses_table[obj.assumedTankSize][obj.installYear][obj.tariffType];
                }
                break;
            }
            case "gas": {
                heatFactor = heat1litreGas;
                obj.energyUnits = 'Gas (MJ)'
                if (obj.optionType !== "GasInstant") {
                    tankLoss = tank_losses_table[obj.assumedTankSize][obj.installYear].Domestic * convertKWhToMj;
                }
                break;
            }
        }

        let totalWater = totalShowerWater() + totalBathWater() +  miscWaterUse() ;
        let energyUsed = (totalWater * heatFactor * 1000) + clothesWashingWater(obj) + tankLoss;

        obj.tankLoss = tankLoss;
        obj.totalEnergyUsed = energyUsed;
    }


    function setEfficiency(obj) {
        let generalType = obj.generalType;
        switch (generalType) {
            case "electric": {
                if (obj.optionType === "ElectPump" || obj.optionType === "ElectSolar") {
                    obj.efficiencyFactor = efficiencySolarHeatPump;
                } else {
                    obj.efficiencyFactor = 1;
                }
                break;
            }
            case "gas": {
                if (obj.optionType === "GasInstant") {
                    obj.efficiencyFactor = efficiencyGasInstant;
                } else if (obj.optionType === "GasSolar") {
                    obj.efficiencyFactor = efficiencySolarHeatPump * efficiencyGasStorage;
                } else {
                    obj.efficiencyFactor = efficiencyGasStorage;
                }
                break;
                }
        }
    }

    function calculateFinalEnergy(obj) {
        obj.finalEnergy = obj.totalEnergyUsed / obj.efficiencyFactor;
    }

    function calculateFinalCost(obj) {
        let existingGas = $('.hotwater_existing-gas').val();
        let additionalGasCharge = 0;
        let energy = obj.finalEnergy;
        let tariff;
        switch (obj.generalType) {
            case "electric": {
                tariff = obj.electTariff;
                break;
            }
            case "gas": {
                tariff = obj.tariffGas;
                break;
            }
        }

        // add gas service charge if system is gas, and is not existing
        if (obj.generalType === "gas" && existingGas === "No") {
            additionalGasCharge = 365 * obj.chargeGas / 100;
        }

        obj.calculatedCost = energy * tariff / 100;
        obj.calculatedCostWithGasCharge = energy * tariff / 100 + additionalGasCharge;

    }

    function calculateValues() {
        setTariffValues(currentSystem, 'currentSystem');
        setTariffValues(newSystem, 'newSystem');
        
        updateAssumedTankSize(currentSystem)
        updateAssumedTankSize(newSystem)

        setInstallYear(currentSystem)
        setInstallYear(newSystem)
        

        energyRequired(currentSystem);
        energyRequired(newSystem);

        setEfficiency(currentSystem);
        setEfficiency(newSystem);

        calculateFinalEnergy(currentSystem);
        calculateFinalEnergy(newSystem);

        calculateFinalCost(currentSystem);
        calculateFinalCost(newSystem);
    
        // Show created system instances with all assigned values
        // console.log(currentSystem);
        // console.log(newSystem);

        
    }


    function generateChart(currrentCost, newCost) {
        var Chart = require('chart.js');
        var ctx = document.getElementById('myChart');
        var myChart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: ['Current System', 'New System'],
                datasets: [{
                    label: 'Remove this title',
                    data: [currrentCost, newCost],
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(54, 162, 235, 0.2)'
                    ],
                    borderColor: [
                        'rgba(255, 99, 132, 1)',
                        'rgba(54, 162, 235, 1)'
                    ],
                    borderWidth: 1
                }],
            },
            options: {
                legend: {
                    display: false
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem) {
                            return tooltipItem.yLabel;
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        });
        myChart.update();
    }



    function showResults() {
        // $('.hotwater_results').css("display", "block");
        $('.calculator_results').slideDown();

        let currentCost = currentSystem.calculatedCostWithGasCharge;
        let newCost = newSystem.calculatedCostWithGasCharge

        // set result usage units and values
        $('.current-hotwater_units').html(currentSystem.energyUnits);
        $('.new-hotwater_units').html(newSystem.energyUnits);
        $('.current-hotwater_usage').html((currentSystem.finalEnergy).toFixed(2));
        $('.new-hotwater_usage').html((newSystem.finalEnergy).toFixed(2));
        
        // set cost values
        $('.current-hotwater_cost').html(currentCost.toFixed(2));
        $('.new-hotwater_cost').html(newCost.toFixed(2));

        // savings
        let difference = (currentCost - newCost).toFixed(2);
        $('.hotwater_savings-value').html(difference);

        // show chart
        generateChart(currentCost, newCost);
    }


    // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
    // End building object values
    // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%



    // "Calculate" click
    $('.hot-water-calculator__wrapper').find('.sq-form-submit').on('click', function (e) {

        // set existing gas question required or not
        if (currentSystem.optionType === undefined || currentSystem.optionType === "gas") {
            $('.hotwater_existing-gas').prop('required', true);
        }

        if (currentSystem.generalType === "gas" || newSystem.generalType === "gas") {
            $('.hotwater_existing-gas').prop('required', true); 
        } else if (currentSystem.generalType === "electric") {
            if (newSystem.generalType === undefined || newSystem.generalType === "electric") {
                $('.hotwater_existing-gas').prop('required', false);  
            } 
        }

        // remove existing graph and add new blank.
        $('#myChart').remove();
        $('.hotwater_graph').append('<canvas id="myChart" width="400" height="400"></canvas>');
        
        let entireForm = document.getElementsByClassName('hot-water-calculator__wrapper')[0].querySelector('form');
        let isFormValid = entireForm.checkValidity(entireForm);

        if (isFormValid) {
            
            e.preventDefault();

            // remove any existing validation errors
			$('.ee-form').find('.sq-form-error').siblings('.error-input').removeClass('error-input');
			$('.ee-form').find('.sq-form-error').remove();


            // set object defaults if selections not changed
            if (!currentSystem.optionType) {
                currentSystem.optionType = $('.current-hotwater_system-type option:selected').val()
                setGeneralEnergyType(currentSystem);
            }
    
            if (!newSystem.optionType) {
                newSystem.optionType = $('.new-hotwater_system-type option:selected').val()
                setGeneralEnergyType(newSystem);
            }


            // custom validation

            let checkCurrentElectTariff = $('.current-hotwater_electric-rate').val();
            let checkNewElectTariff = $('.new-hotwater_electric-rate').val();

            var checkOnlyDigits = function (string) {
                return /^(?=.)([+-]?([0-9]*)(\.([0-9]+))?)$/.test(string);
            }

			var errorMessage  = `<p class="sq-form-error">This value must be a number.</p>`

			
			if (!checkOnlyDigits(checkCurrentElectTariff)) {
				$('.current-hotwater_electric-rate').addClass('error-input');
				$('.current-hotwater_electric-rate').parent().append(errorMessage);
			}

			if (!checkOnlyDigits(checkNewElectTariff)) {
				$('.new-hotwater_electric-rate').addClass('error-input');
				$('.new-hotwater_electric-rate').parent().append(errorMessage);
			}

			// do not allow calculations if either value contains characters
			if (!checkOnlyDigits(checkCurrentElectTariff) || !checkOnlyDigits(checkNewElectTariff)) {
				return;
			}
    
            calculateValues();
    
            showResults();

            $('html, body').animate({
				scrollTop: $("#calculator-results").offset().top
			}, 800);
        }
    })

}());